<template>
  <v-list-item class="px-0" v-if="isMenu" :href="sessionHistoryUrl" target="_blank">
    <v-list-item-action>
      <v-icon>mdi-history</v-icon>
    </v-list-item-action>
    <v-list-item-content>
      <v-list-item-title>Historial de sesiones</v-list-item-title>
    </v-list-item-content>
  </v-list-item>
  <v-toolbar dense flat v-else-if="!mobile" color="#f1f8e9" class="my-2">
    <template v-if="$vuetify.breakpoint.mobile">
      <v-toolbar-title class="ml-2 ">{{$route.name}}</v-toolbar-title>
    </template>
    <template v-else>
      <span class="ml-2 text-h4 font-weight-medium">{{$route.name}}</span>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <div class="fh-content">
          <a class="fh-link" :href="sessionHistoryUrl" target="_blank">
            Acceso anterior: {{ fechaHoraAccesoAnterior }}
          </a>
        </div>
      </v-toolbar-items>
    </template>
  </v-toolbar>
  <v-list-item dense class="px-0" v-else-if="mobile">
    <v-list-item-content>
      <a class="fh-link" :href="sessionHistoryUrl" target="_blank">
      Acceso anterior: {{ fechaHoraAccesoAnterior }}
      </a>
    </v-list-item-content>
  </v-list-item>
  
</template>

<script>
import SessionService from '@/services/SessionService'
import {SESSION_HISTORY_URL} from '@/config'

export default {
  name: 'FhAccesoAnterior',
  props: {
    isMenu: Boolean,
    mobile: Boolean,
  },
  computed: {
    fechaHoraAccesoAnterior() {
      let value = SessionService.getFechaHoraAccesoAnterior()
      if (!value) return value

      let date = new Date(Date.parse(value))
      let dateNow = new Date()
      let dateYesterday = new Date(dateNow - 24*60*60*1000)

      let day = ''
      let month = ''
      let year = ', '

      // if today
      if (date.getFullYear() === dateNow.getFullYear() && date.getMonth() === dateNow.getMonth() && date.getDate() === dateNow.getDate()) {
        day = 'Hoy'
      }
      // else if yesterday
      else if (date.getFullYear() === dateYesterday.getFullYear() && date.getMonth() === dateYesterday.getMonth() && date.getDate() === dateYesterday.getDate()) {
        day = 'Ayer'
      }
      else {
        let weekdayList = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado']

      // weekday and day of month
        day = weekdayList[date.getDay()] + ', ' + date.getDate()

        // month (this month empty)
        let monthList = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre']
        if (date.getFullYear() !== dateNow.getFullYear() || (date.getFullYear() === dateNow.getFullYear() && date.getMonth() !== dateNow.getMonth())) {
          month = ' de ' + monthList[date.getMonth()]
        }

        // year (this year empty)
        if (date.getFullYear() !== dateNow.getFullYear()) {
          year = ' del ' + date.getFullYear() + ', '
        }
      }

      // time
      let hour = (date.getHours() + '').padStart(2, '0')
      let minutes = (date.getMinutes() + '').padStart(2, '0')
      let time = hour + ':' + minutes

      return day + month + year + time
    },
    sessionHistoryUrl() {
      return SESSION_HISTORY_URL
    },
  },
  methods: {
  }
}
</script>

<style scoped>
.fh-content {
  font-size: 14px;
  margin-right: 16px;
  margin-top: 14px;
}

.fh-link {
  color: #333;
  text-decoration: none;
}

.gradient {
    background-color: #fff59d; /* For browsers that do not support gradients */
    background-image: linear-gradient(to bottom , #fff59d, #f1f8e9);
  }
</style>